export default __webpack_public_path__ + "locales/tr/PrivacyPage.json?hash=a5429662fa6c221b08c6c13d01f44ef7";